module.exports = __webpack_public_path__ + "img/internet-3.02d8aa9e.jpg";